function getObjectEntries(obj) {
  return [
    ...Object.getOwnPropertyNames(obj),
    ...Object.getOwnPropertySymbols(obj)
  ];
}
export {
  getObjectEntries
};
//# sourceMappingURL=GetObjectEntries.js.map
